import React, { useRef, useState, useEffect } from 'react';
import parse from 'html-react-parser';
import Slider from 'react-slick';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import { ArrowThickLeft, ArrowThickRight } from './icons';
import Fade from 'react-reveal/Fade';

const CardSlider = ({ subtitle, title, items }) => {
  const sliderRef = useRef(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [slidesShowing, setSlidesShowing] = useState(0);

  let settings = {
    autoplay: false,
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    centerMode: false,
    centerPadding: '0',
    afterChange: (currentSlide) => {
      setCurrentSlide(currentSlide);
    },
    responsive: [
      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.innerWidth < 900 ? setSlidesShowing(0) : setSlidesShowing(3);
      window.addEventListener('resize', () => {
        window.innerWidth < 900 ? setSlidesShowing(0) : setSlidesShowing(3)
      });
    }
  })

  return (
    <section className='card-slider'>
      <div className='card-slider__inner'>
        <div
          className='card-slider__wrapper'
          data-sal='fade'
          data-sal-duration='1000'
          data-sal-delay='0'
          data-sal-easing='ease'
        >
          <Fade bottom distance='40px'>
            <div className='card-slider__title'>
              {subtitle && <p>{parse(subtitle)}</p>}
              {title && <h2>{parse(title)}</h2>}
            </div>
          </Fade>
          <span className='card-slider__count'>{currentSlide + 1} / {items.length}</span>
          <div className={`card-slider__navigator ${items.length < 5 ? 'no-arrows' : ''}`}>
            <button onClick={() => sliderRef.current.slickPrev()} disabled={currentSlide === 0 ? true : false} className={`${currentSlide === 0 ? 'disabled' : ''}`}>
              <ArrowThickLeft />
            </button>
            <button onClick={() => sliderRef.current.slickNext()} disabled={currentSlide + slidesShowing === items.length - 1 ? true : false} className={`${currentSlide + slidesShowing === items.length - 1 ? 'disabled' : ''}`}>
              <ArrowThickRight />
            </button>
          </div>
        </div>
      </div>
      <Fade bottom distance='40px'>
        <div className='card-slider__items'>
          <Slider ref={sliderRef} {...settings}>
            {items.length > 0 &&
              items.map((el, i) => (
                <div key={i} className='card-slider__item'>
                  {el.image && (
                    <GatsbyImage loading='lazy' image={getImage(el.image.localFile)} alt={el.title} />
                  )}
                  {el.title && <h3>{el.title}</h3>}
                  {el.content && <p>{el.content}</p>}
                </div>
              ))}
          </Slider>
        </div>
      </Fade>
    </section>
  );
};

export default CardSlider;